import { Component, OnInit } from '@angular/core';
import { AttendanceDayDrawerComponent } from './presentation/components/hrManagement/attendance/day-drawer/attendance-day-drawer.component';
import { RouterOutlet, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from './shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { routes } from './app.routes';
import { LanguageService } from './application/services/language.service';
import { ThemeService } from './application/services/theme.service';
import { FontSizeService } from './application/services/font-size.service';
import { Subscription } from 'rxjs';
import { SupportSessionBannerComponent } from './shared/support-session-banner/support-session-banner.component';
import { ConfirmDialogHostComponent } from './shared/confirm-dialog/confirm-dialog-host.component';
import { PwaPromptsComponent } from './shared/pwa/pwa-prompts.component';

import { startWebVitals } from './core/observability/web-vitals';
@Component({
    selector: 'app-root',
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        FormsModule,
        HttpClientModule,
        SupportSessionBannerComponent,
        ConfirmDialogHostComponent,
        AttendanceDayDrawerComponent,
        PwaPromptsComponent,
    ],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit   {
  title = 'erp_front';
  private fontSub!: Subscription;

 constructor(
    public langService: LanguageService,
    private themeService: ThemeService,
    private fontSizeService: FontSizeService
  ) {}
  ngOnInit() {
    this.themeService.loadTheme();
    startWebVitals();   // OPS-02-T03: sampled Core Web Vitals
    this.fontSub = this.fontSizeService.fontSize$.subscribe(size => {
      document.documentElement.style.setProperty('--app-font-size', `${size}px`);
    });
  }
}
